import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';


function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Chairman" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                            <h4>
                                <i className="fal fa-graduation-cap me-3 mb-2" />Sajjan Jindal Chairman, JSW Group
                            </h4>
          

                        </div>
                        
                    </div>
                    
                </div>

                <div className="container">
                <Row>
                <Col md={9} className='c-right'>

                            <p>An accomplished Business Leader and a second-generation entrepreneur, <b> Mr. Sajjan Jindal </b> had the foresight to lead the Steel industry and JSW in particular on a transformational journey, contributing significantly to India’s growth philosophy. With a visionary approach, he has transformed the Steel industry and the JSW Group, expanding the business landscape across Energy, Infrastructure, Sports, Cement, and Paints. A mechanical engineer, Mr. Jindal has led the JSW Group through some of its most exciting phases, including the public offer announcements of JSW Steel and JSW Energy in 1995 and 2009-10, respectively.</p>

                    <p>Today, the USD 23 Billion Group takes pride in its outstanding growth and success. Mr. Jindal is a firm believer in the “Make in India” philosophy and has received several global awards for his commendable work. He was awarded the “EY Entrepreneur of the Year” in Feb 2023, and in the past, he received the “CEO of the Year 2019” Award by Business Standard (India’s leading business publication) and the “Best CEO Award 2019” by Business Today Magazine. He has also been recognized as the “Outstanding Business Leader of the year 2018” by IBLA - CNBC TV18 (India’s leading business news channel). </p>

                    <p>Furthermore, he was awarded the JRD Tata Award 2017 for “Excellence in Corporate Leadership in Metallurgical industry,” and the “2014 National Metallurgist Award: Industry” instituted by the Ministry of Steel, Government of India. Apart from his business endeavors, Mr. Jindal is keen on giving back to society and improving the lives of individuals. He founded the JSW Foundation, which is committed to providing opportunities to bridge the socioeconomic divide and create equitable and sustainable communities.</p>

                    <p>The Foundation has touched the lives of over 1 million people, providing them with the means to empower themselves and build a brighter and sustainable future. Mr. Jindal is globally recognized for his impact on the steel industry and currently serves as the Vice Chairman of the World Steel Association, one of the largest and most dynamic industry associations in the world. He is also the Vice President & Chairman, Ferrous Division of the Indian Institute of Metals, and was the past President of Indian Steel Association (ISA) and former President of the Institute of Steel Development & Growth (INSDAG). Additionally, he was the past Chairman of the World Steel Association, and the first representative from an Indian company to serve in this role. </p>

               </Col>
                <Col md={3} className='c-right'>

                            {/*--------------------------- Head of the dept */}
                            {/* <h3 className='c-headline text-center mb-3'> </h3> */}
                            <div className="row justify-content-center">
                                <img className="mb-3" src="https://files.iittp.ac.in/images/demo/iit/Sajjan Jindal_BoG_Chairman.png" alt="" width="160" height="360"></img>
                             
                            </div>
                            <h3 className='c-headline text-center mb-3'> </h3>
                            <h3 className='c-headline text-center mt-3'>Chairman
                                Board of Governors
                                IIT Tirupati </h3>
                         
                            {/*--------------------------- Volunteers*/}
                            
                </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main